export default "__VITE_ASSET__6EcQ2ReQ__"